import 'react-querybuilder/dist/query-builder.css';
import { QueryBuilderAntD, AntDValueEditor, AntDValueSelector, antdControlElements } from '@react-querybuilder/antd';
import { QueryBuilder as ReactQueryBuilder, type QueryBuilderProps } from 'react-querybuilder';
import { Input, Select, Space } from 'antd';

export { formatQuery } from 'react-querybuilder';
export type { RuleGroupType } from 'react-querybuilder';

function normalizeForFulltext(str: string) {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

const CommonSelector = props => (
  <AntDValueSelector {...props} showSearch popupMatchSelectWidth={false} style={{ minWidth: 100 }} />
);

// TODO unify FlowrateEditor with flowrate on meter details
const FlowrateEditor = props => {
  const { value, handleOnChange } = props;

  const parts = (value ?? '').split(' ');
  const prefix = parts[0] ?? '';
  const number = parts[1] ?? '';

  return (
    <Space.Compact>
      <Select
        style={{ width: 80 }}
        value={prefix}
        onChange={newPrefix => {
          handleOnChange(`${newPrefix} ${number}`.trim());
        }}
      >
        <Select.Option value="Q3">Q3</Select.Option>
        <Select.Option value="Qn">Qn</Select.Option>
        <Select.Option value="Qp">Qp</Select.Option>
      </Select>
      <Input
        prefix
        placeholder="Value"
        style={{ width: 150 }}
        type="number"
        value={number}
        onChange={e => {
          handleOnChange(`${prefix} ${e.target.value}`.trim());
        }}
      />
    </Space.Compact>
  );
};

const ExtendedValueEditor = props => {
  if (props.fieldData.inputType === 'flowrate') {
    return <FlowrateEditor {...props} />;
  }
  return (
    <AntDValueEditor
      {...props}
      showSearch
      filterOption={(input: string, { children }: { children?: unknown }) => {
        return normalizeForFulltext(typeof children === 'string' ? children : '').includes(normalizeForFulltext(input));
      }}
      style={{ minWidth: 250 }}
    />
  );
};

export const QueryBuilder = (props: QueryBuilderProps) => (
  <QueryBuilderAntD>
    <ReactQueryBuilder
      {...props}
      controlElements={{
        ...antdControlElements,
        operatorSelector: CommonSelector,
        fieldSelector: CommonSelector,
        valueEditor: ExtendedValueEditor,
      }}
    />
  </QueryBuilderAntD>
);
